<app-stepper-form
  header="Cease as a Registered Agent"
  subheader="Form 361"
  formIcon="ic-registered-agent-ceasing-20"
  [showSteps]="false"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [isLoading]="isLoading"
  [form]="stepperForm"
>
  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="361"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [formGroupName]="StepsEnum.RegisteredAgentCeasing"
      [hidden]="currentStep !== StepsEnum.RegisteredAgentCeasing"
    >
      <h1 class="h1-heading">{{ steps[currentStepIndex].label }}</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Cessation"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      <div class="form-group">
        <app-company-name-acn-form-group [formGroup]="form"/>
      </div>
    </section>
  </div>
</app-stepper-form>
